import { PublicationTemplateOption } from './types'

export function getPublicationTemplateOptionsForPreview(input: {
  format?: string
  intent?: string
  sector?: string
}) {
  const format = input.format || 'carousel'
  const intent = input.intent || ''
  const sector = input.sector || ''

  const matches = publicationTemplateOptions.filter((template) => {
    const isPremiumPack = template.templateId === 'sector-intent-pack'
    const formatMatch = template.format === format
    const intentMatch = !intent || !template.intent?.length || template.intent.includes(intent)
    return isPremiumPack && formatMatch && intentMatch
  })

  return matches.sort((a, b) => {
    const aSameSector = a.sector?.includes(sector) ? 1 : 0
    const bSameSector = b.sector?.includes(sector) ? 1 : 0
    return bSameSector - aSameSector
  })
}

export const publicationTemplateOptions: PublicationTemplateOption[] = [    
  {
    id: 'creator-announcement-sector-pack',
    name: 'Creator Announcement',
    description: 'Pack premium por objetivo: announcement. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['announcement'],
    sector: ['creator_personal_brand'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'creator-announcement',
    preview: {
      background: '#ECE7DB',
      accent: '#B83A2E',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'announcement_objective_v2',
      headline: 'Announcement\nPack',
      subheadline: 'Creator Announcement',
      badge: 'announcement',
    },
  },
  {
    id: 'creator-authority-sector-pack',
    name: 'Creator Authority',
    description: 'Pack premium por objetivo: authority. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['authority'],
    sector: ['creator_personal_brand'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'creator-authority',
    preview: {
      background: '#ECE7DB',
      accent: '#B83A2E',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'authority_objective_v2',
      headline: 'Authority\nPack',
      subheadline: 'Creator Authority',
      badge: 'authority',
    },
  },
  {
    id: 'creator-carousel-sector-pack',
    name: 'Creator Carousel',
    description: 'Pack premium por objetivo: carousel. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['carousel'],
    sector: ['creator_personal_brand'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'creator-carousel',
    preview: {
      background: '#ECE7DB',
      accent: '#B83A2E',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'carousel_objective_v2',
      headline: 'Carousel\nPack',
      subheadline: 'Creator Carousel',
      badge: 'carousel',
    },
  },
  {
    id: 'creator-community-sector-pack',
    name: 'Creator Community',
    description: 'Pack premium por objetivo: community. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['community'],
    sector: ['creator_personal_brand'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'creator-community',
    preview: {
      background: '#ECE7DB',
      accent: '#B83A2E',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'community_objective_v2',
      headline: 'Community\nPack',
      subheadline: 'Creator Community',
      badge: 'community',
    },
  },
  {
    id: 'creator-educational-sector-pack',
    name: 'Creator Educational',
    description: 'Pack premium por objetivo: educational. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['educational'],
    sector: ['creator_personal_brand'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'creator-educational',
    preview: {
      background: '#ECE7DB',
      accent: '#B83A2E',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'educational_objective_v2',
      headline: 'Educational\nPack',
      subheadline: 'Creator Educational',
      badge: 'educational',
    },
  },
  {
    id: 'creator-offer-sector-pack',
    name: 'Creator Offer',
    description: 'Pack premium por objetivo: offer. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['offer'],
    sector: ['creator_personal_brand'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'creator-offer',
    preview: {
      background: '#ECE7DB',
      accent: '#B83A2E',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'offer_objective_v2',
      headline: 'Offer\nPack',
      subheadline: 'Creator Offer',
      badge: 'offer',
    },
  },
  {
    id: 'creator-story-sector-pack',
    name: 'Creator Story',
    description: 'Pack premium por objetivo: story. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['story'],
    sector: ['creator_personal_brand'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'creator-story',
    preview: {
      background: '#ECE7DB',
      accent: '#B83A2E',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'story_objective_v2',
      headline: 'Story\nPack',
      subheadline: 'Creator Story',
      badge: 'story',
    },
  },
  {
    id: 'creator-testimonial-sector-pack',
    name: 'Creator Testimonial',
    description: 'Pack premium por objetivo: testimonial. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['testimonial'],
    sector: ['creator_personal_brand'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'creator-testimonial',
    preview: {
      background: '#ECE7DB',
      accent: '#B83A2E',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'testimonial_objective_v2',
      headline: 'Testimonial\nPack',
      subheadline: 'Creator Testimonial',
      badge: 'testimonial',
    },
  },
  {
    id: 'beauty-announcement-sector-pack',
    name: 'Beauty Announcement',
    description: 'Pack premium por objetivo: announcement. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['announcement'],
    sector: ['beauty_skincare'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'beauty-announcement',
    preview: {
      background: '#F4EEE5',
      thumbnailUrl: '/images/creator-studio/publications/carousel_templates/beauty_01/announcement_thumbnail.jpg',
      accent: '#B18A4A',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'announcement_objective_v2',
      headline: 'Announcement\nPack',
      subheadline: 'Beauty Announcement',
      badge: 'announcement',
    },
  },
  {
    id: 'beauty-authority-sector-pack',
    name: 'Beauty Authority',
    description: 'Pack premium por objetivo: authority. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['authority'],
    sector: ['beauty_skincare'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'beauty-authority',
    preview: {
      background: '#F4EEE5',
      thumbnailUrl: '/images/creator-studio/publications/carousel_templates/beauty_01/authority_thumbnail.jpg',
      accent: '#B18A4A',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'authority_objective_v2',
      headline: 'Authority\nPack',
      subheadline: 'Beauty Authority',
      badge: 'authority',
    },
  },
  {
    id: 'beauty-community-sector-pack',
    name: 'Beauty Community',
    description: 'Pack premium por objetivo: community. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['community'],
    sector: ['beauty_skincare'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'beauty-community',
    preview: {
      background: '#F4EEE5',
      thumbnailUrl: '/images/creator-studio/publications/carousel_templates/beauty_01/community_thumbnail.jpg',
      accent: '#B18A4A',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'community_objective_v2',
      headline: 'Community\nPack',
      subheadline: 'Beauty Community',
      badge: 'community',
    },
  },
  {
    id: 'beauty-educational-routine-sector-pack',
    name: 'Beauty EducationalRoutine',
    description: 'Pack premium por objetivo: educational. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['educational'],
    sector: ['beauty_skincare'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'beauty-educational-routine',
    preview: {
      background: '#F4EEE5',
      thumbnailUrl: '/images/creator-studio/publications/carousel_templates/beauty_01/educational_thumbnail.jpg',
      accent: '#B18A4A',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'educational_objective_v2',
      headline: 'Educational\nPack',
      subheadline: 'Beauty EducationalRoutine',
      badge: 'educational',
    },
  },
  {
    id: 'beauty-luxury-offer-sector-pack',
    name: 'Beauty LuxuryOffer',
    description: 'Pack premium por objetivo: offer. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['offer'],
    sector: ['beauty_skincare'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'beauty-luxury-offer',
    preview: {
      background: '#F4EEE5',
      thumbnailUrl: '/images/creator-studio/publications/carousel_templates/beauty_01/offer_thumbnail.jpg',
      accent: '#B18A4A',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'offer_objective_v2',
      headline: 'Offer\nPack',
      subheadline: 'Beauty LuxuryOffer',
      badge: 'offer',
    },
  },
  {
    id: 'beauty-story-sector-pack',
    name: 'Beauty Story',
    description: 'Pack premium por objetivo: story. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['story'],
    sector: ['beauty_skincare'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'beauty-story',
    preview: {
      background: '#F4EEE5',
      thumbnailUrl: '/images/creator-studio/publications/carousel_templates/beauty_01/story_thumbnail.jpg',
      accent: '#B18A4A',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'story_objective_v2',
      headline: 'Story\nPack',
      subheadline: 'Beauty Story',
      badge: 'story',
    },
  },
  {
    id: 'beauty-testimonial-sector-pack',
    name: 'Beauty Testimonial',
    description: 'Pack premium por objetivo: testimonial. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['testimonial'],
    sector: ['beauty_skincare'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'beauty-testimonial',
    preview: {
      background: '#F4EEE5',
      thumbnailUrl: '/images/creator-studio/publications/carousel_templates/beauty_01/testimonial_thumbnail.jpg',
      accent: '#B18A4A',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'testimonial_objective_v2',
      headline: 'Testimonial\nPack',
      subheadline: 'Beauty Testimonial',
      badge: 'testimonial',
    },
  },
  {
    id: 'corporate-authority-sector-pack',
    name: 'Corporate Authority',
    description: 'Pack premium por objetivo: authority. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['authority'],
    sector: ['business_corporate'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'corporate-authority',
    preview: {
      background: '#F3F5F7',
      accent: '#2457D6',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'authority_objective_v2',
      headline: 'Authority\nPack',
      subheadline: 'Corporate Authority',
      badge: 'authority',
    },
  },
  {
    id: 'corporate-carousel-sector-pack',
    name: 'Corporate Carousel',
    description: 'Pack premium por objetivo: carousel. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['carousel'],
    sector: ['business_corporate'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'corporate-carousel',
    preview: {
      background: '#F3F5F7',
      accent: '#2457D6',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'carousel_objective_v2',
      headline: 'Carousel\nPack',
      subheadline: 'Corporate Carousel',
      badge: 'carousel',
    },
  },
  {
    id: 'corporate-case-study-testimonial-sector-pack',
    name: 'Corporate CaseStudyTestimonial',
    description: 'Pack premium por objetivo: testimonial. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['testimonial'],
    sector: ['business_corporate'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'corporate-case-study-testimonial',
    preview: {
      background: '#F3F5F7',
      accent: '#2457D6',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'testimonial_objective_v2',
      headline: 'Testimonial\nPack',
      subheadline: 'Corporate CaseStudyTestimonial',
      badge: 'testimonial',
    },
  },
  {
    id: 'corporate-community-sector-pack',
    name: 'Corporate Community',
    description: 'Pack premium por objetivo: community. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['community'],
    sector: ['business_corporate'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'corporate-community',
    preview: {
      background: '#F3F5F7',
      accent: '#2457D6',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'community_objective_v2',
      headline: 'Community\nPack',
      subheadline: 'Corporate Community',
      badge: 'community',
    },
  },
  {
    id: 'corporate-educational-sector-pack',
    name: 'Corporate Educational',
    description: 'Pack premium por objetivo: educational. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['educational'],
    sector: ['business_corporate'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'corporate-educational',
    preview: {
      background: '#F3F5F7',
      accent: '#2457D6',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'educational_objective_v2',
      headline: 'Educational\nPack',
      subheadline: 'Corporate Educational',
      badge: 'educational',
    },
  },
  {
    id: 'corporate-executive-announcement-sector-pack',
    name: 'Corporate ExecutiveAnnouncement',
    description: 'Pack premium por objetivo: announcement. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['announcement'],
    sector: ['business_corporate'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'corporate-executive-announcement',
    preview: {
      background: '#F3F5F7',
      accent: '#2457D6',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'announcement_objective_v2',
      headline: 'Announcement\nPack',
      subheadline: 'Corporate ExecutiveAnnouncement',
      badge: 'announcement',
    },
  },
  {
    id: 'corporate-offer-sector-pack',
    name: 'Corporate Offer',
    description: 'Pack premium por objetivo: offer. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['offer'],
    sector: ['business_corporate'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'corporate-offer',
    preview: {
      background: '#F3F5F7',
      accent: '#2457D6',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'offer_objective_v2',
      headline: 'Offer\nPack',
      subheadline: 'Corporate Offer',
      badge: 'offer',
    },
  },
  {
    id: 'corporate-story-sector-pack',
    name: 'Corporate Story',
    description: 'Pack premium por objetivo: story. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['story'],
    sector: ['business_corporate'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'corporate-story',
    preview: {
      background: '#F3F5F7',
      accent: '#2457D6',
      text: '#111111',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'story_objective_v2',
      headline: 'Story\nPack',
      subheadline: 'Corporate Story',
      badge: 'story',
    },
  },
  {
    id: 'event-authority-sector-pack',
    name: 'Event Authority',
    description: 'Pack premium por objetivo: authority. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['authority'],
    sector: ['events_webinars'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'event-authority',
    preview: {
      background: '#100B1F',
      accent: '#FFB000',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'authority_objective_v2',
      headline: 'Authority\nPack',
      subheadline: 'Event Authority',
      badge: 'authority',
    },
  },
  {
    id: 'event-carousel-sector-pack',
    name: 'Event Carousel',
    description: 'Pack premium por objetivo: carousel. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['carousel'],
    sector: ['events_webinars'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'event-carousel',
    preview: {
      background: '#100B1F',
      accent: '#FFB000',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'carousel_objective_v2',
      headline: 'Carousel\nPack',
      subheadline: 'Event Carousel',
      badge: 'carousel',
    },
  },
  {
    id: 'event-community-sector-pack',
    name: 'Event Community',
    description: 'Pack premium por objetivo: community. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['community'],
    sector: ['events_webinars'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'event-community',
    preview: {
      background: '#100B1F',
      accent: '#FFB000',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'community_objective_v2',
      headline: 'Community\nPack',
      subheadline: 'Event Community',
      badge: 'community',
    },
  },
  {
    id: 'event-conversion-offer-sector-pack',
    name: 'Event ConversionOffer',
    description: 'Pack premium por objetivo: announcement. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['announcement'],
    sector: ['events_webinars'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'event-conversion-offer',
    preview: {
      background: '#100B1F',
      accent: '#FFB000',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'announcement_objective_v2',
      headline: 'Announcement\nPack',
      subheadline: 'Event ConversionOffer',
      badge: 'announcement',
    },
  },
  {
    id: 'event-educational-sector-pack',
    name: 'Event Educational',
    description: 'Pack premium por objetivo: educational. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['educational'],
    sector: ['events_webinars'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'event-educational',
    preview: {
      background: '#100B1F',
      accent: '#FFB000',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'educational_objective_v2',
      headline: 'Educational\nPack',
      subheadline: 'Event Educational',
      badge: 'educational',
    },
  },
  {
    id: 'event-story-sector-pack',
    name: 'Event Story',
    description: 'Pack premium por objetivo: story. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['story'],
    sector: ['events_webinars'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'event-story',
    preview: {
      background: '#100B1F',
      accent: '#FFB000',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'story_objective_v2',
      headline: 'Story\nPack',
      subheadline: 'Event Story',
      badge: 'story',
    },
  },
  {
    id: 'event-testimonial-sector-pack',
    name: 'Event Testimonial',
    description: 'Pack premium por objetivo: testimonial. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['testimonial'],
    sector: ['events_webinars'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'event-testimonial',
    preview: {
      background: '#100B1F',
      accent: '#FFB000',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'testimonial_objective_v2',
      headline: 'Testimonial\nPack',
      subheadline: 'Event Testimonial',
      badge: 'testimonial',
    },
  },
  {
    id: 'event-webinar-announcement-sector-pack',
    name: 'Event WebinarAnnouncement',
    description: 'Pack premium por objetivo: announcement. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['announcement'],
    sector: ['events_webinars'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'event-webinar-announcement',
    preview: {
      background: '#100B1F',
      accent: '#FFB000',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'announcement_objective_v2',
      headline: 'Announcement\nPack',
      subheadline: 'Event WebinarAnnouncement',
      badge: 'announcement',
    },
  },
  {
    id: 'fitness-authority-sector-pack',
    name: 'Fitness Authority',
    description: 'Pack premium por objetivo: authority. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['authority'],
    sector: ['fitness_wellness'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'fitness-authority',
    preview: {
      background: '#111111',
      accent: '#B6FF3B',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'authority_objective_v2',
      headline: 'Authority\nPack',
      subheadline: 'Fitness Authority',
      badge: 'authority',
    },
  },
  {
    id: 'fitness-carousel-sector-pack',
    name: 'Fitness Carousel',
    description: 'Pack premium por objetivo: carousel. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['carousel'],
    sector: ['fitness_wellness'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'fitness-carousel',
    preview: {
      background: '#111111',
      accent: '#B6FF3B',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'carousel_objective_v2',
      headline: 'Carousel\nPack',
      subheadline: 'Fitness Carousel',
      badge: 'carousel',
    },
  },
  {
    id: 'fitness-challenge-announcement-sector-pack',
    name: 'Fitness ChallengeAnnouncement',
    description: 'Pack premium por objetivo: announcement. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['announcement'],
    sector: ['fitness_wellness'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'fitness-challenge-announcement',
    preview: {
      background: '#111111',
      accent: '#B6FF3B',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'announcement_objective_v2',
      headline: 'Announcement\nPack',
      subheadline: 'Fitness ChallengeAnnouncement',
      badge: 'announcement',
    },
  },
  {
    id: 'fitness-community-sector-pack',
    name: 'Fitness Community',
    description: 'Pack premium por objetivo: community. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['community'],
    sector: ['fitness_wellness'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'fitness-community',
    preview: {
      background: '#111111',
      accent: '#B6FF3B',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'community_objective_v2',
      headline: 'Community\nPack',
      subheadline: 'Fitness Community',
      badge: 'community',
    },
  },
  {
    id: 'fitness-educational-sector-pack',
    name: 'Fitness Educational',
    description: 'Pack premium por objetivo: educational. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['educational'],
    sector: ['fitness_wellness'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'fitness-educational',
    preview: {
      background: '#111111',
      accent: '#B6FF3B',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'educational_objective_v2',
      headline: 'Educational\nPack',
      subheadline: 'Fitness Educational',
      badge: 'educational',
    },
  },
  {
    id: 'fitness-offer-sector-pack',
    name: 'Fitness Offer',
    description: 'Pack premium por objetivo: offer. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['offer'],
    sector: ['fitness_wellness'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'fitness-offer',
    preview: {
      background: '#111111',
      accent: '#B6FF3B',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'offer_objective_v2',
      headline: 'Offer\nPack',
      subheadline: 'Fitness Offer',
      badge: 'offer',
    },
  },
  {
    id: 'fitness-testimonial-sector-pack',
    name: 'Fitness Testimonial',
    description: 'Pack premium por objetivo: testimonial. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['testimonial'],
    sector: ['fitness_wellness'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'fitness-testimonial',
    preview: {
      background: '#111111',
      accent: '#B6FF3B',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'testimonial_objective_v2',
      headline: 'Testimonial\nPack',
      subheadline: 'Fitness Testimonial',
      badge: 'testimonial',
    },
  },
  {
    id: 'fitness-transformation-story-sector-pack',
    name: 'Fitness TransformationStory',
    description: 'Pack premium por objetivo: story. Compatible con cambio de diseño por intención.',
    format: 'carousel',
    intent: ['story'],
    sector: ['fitness_wellness'],
    visualStyle: 'premium_objective_v2',
    templateId: 'sector-intent-pack',
    themeId: 'fitness-transformation-story',
    preview: {
      background: '#111111',
      accent: '#B6FF3B',
      text: '#FFFFFF',
      muted: 'rgba(0,0,0,0.55)',
      layout: 'story_objective_v2',
      headline: 'Story\nPack',
      subheadline: 'Fitness TransformationStory',
      badge: 'story',
    },
  },
]

export function getPublicationTemplateOptions(input: {
  format?: string
  intent?: string
  sector?: string
}) {
  const format = input.format || 'image'
  const intent = input.intent || ''
  const sector = input.sector || ''

  const matches = publicationTemplateOptions.filter((template) => {
    const formatMatch = template.format === format
    const intentMatch = !intent || !template.intent?.length || template.intent.includes(intent)
    const sectorMatch = !sector || !template.sector?.length || template.sector.includes(sector)

    return formatMatch && intentMatch && sectorMatch
  })

  if (matches.length) return matches

  return publicationTemplateOptions.filter((template) => template.format === format)
}

export function getPublicationTemplateById(id?: string | null) {
  if (!id) return null
  return publicationTemplateOptions.find((template) => template.id === id) || null
}